<template>
  <div class="d-flex">
    <v-divider
      v-if="!hideDivider"
      vertical
      class="mr-3"
      :class="themeOptions[theme].primary"
    />
    <h4
      class="d-flex align-center title-gap sub-title text-uppercase align-self-center"
    >
      <img
        class="inplay-icon"
        :src="title === 'Upcoming' ? upcomingIcon : inplayIcon"
        alt=""
      />
      <span :class="`${themeOptions[theme].primary}--text`">
        {{ title }}
        <span v-if="itemCount > 0"> ({{ itemCount }})</span>
      </span>
    </h4>
    <v-spacer />
    <v-btn
      v-if="btnLink"
      class="align-self-center"
      small
      rounded
      outlined
      :color="themeOptions[theme].primary"
      :to="btnLink"
    >
      <span
        :class="{
          'black--text': !$vuetify.theme.dark && theme != 'white',
          'white--text': $vuetify.theme.dark
        }"
      >
        View All
      </span>
      <v-icon
        size="18px"
        :class="themeOptions[theme].primary"
        class="rounded-item"
        :color="themeOptions[theme].secondary"
        right
      >
        mdi-plus
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import upcomingIcon from '@/assets/images/upcomingico.png'
import inplayIcon from '@/assets/images/inplayico.png'
export default {
  name: 'SectionHead',
  props: {
    title: { type: String, default: '', required: true },
    theme: { type: String, default: 'default' },
    icon: { type: String, default: 'mdi-play-circle', required: false },
    itemCount: {
      type: [Number, String],
      default: 0,
      required: false
    },
    btnLink: { type: String, default: undefined },
    hideDivider: { type: Boolean, default: false },
    hideIcons: { type: Boolean, default: true }
  },
  data: () => ({
    inplayIcon,
    upcomingIcon,
    themeOptions: {
      white: {
        primary: 'white',
        secondary: 'primary'
      },
      default: {
        primary: 'primary',
        secondary: 'white'
      }
    }
  })
}
</script>
<style scoped>
.inplay-icon {
  width: 22px;
  height: 22px;
}
.title-gap {
  gap: 5px;
}
</style>
